/* eslint-disable camelcase */
import { URLS } from '~/constants';
import EmojiConvertor from 'emoji-js';

const emojiPath = URLS.EMOJIS;

const createNewEmojiConvertor = () => {
  const emojiConvertor = new EmojiConvertor();
  emojiConvertor.img_sets.google.path = emojiPath;
  emojiConvertor.img_sets.apple.path = emojiPath;
  emojiConvertor.use_sheet = false;
  emojiConvertor.init_env();
  emojiConvertor.img_set = 'google';
  emojiConvertor.text_mode = false;
  emojiConvertor.replace_mode = 'img';
  emojiConvertor.supports_css = false;
  emojiConvertor.include_title = true;
  emojiConvertor.addAliases({
    'star-struck': '1f929',
    mrs_claus: '1f936',
    face_with_hand_over_mouth: '1f92d',
    face_with_raised_eyebrow: '1f928',
    exploding_head: '1f92f',
    zany_face: '1f92a',
    face_with_symbols_on_mouth: '1f92c',
    face_vomiting: '1f92e',
    shushing_face: '1f92b',
    crossed_fingers: '1f91e',
    medical_symbol: '2695-fe0f',
  });
  return emojiConvertor;
};

export const emojiConvertor = createNewEmojiConvertor();

const nativeEmojiToColons = createNewEmojiConvertor();
nativeEmojiToColons.colons_mode = true;

export const convertEmojiToImgEmoji = (text) => {
  return emojiConvertor.replace_colons(text);
};

export const convertNativeEmojiToColons = (text: string) => {
  return nativeEmojiToColons.replace_unified(text);
};
